import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
import EditCarouselModal from '../../Modals/Carousel/EditCarouselModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllCarouselsTable extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            carouselInEdit: null,
            carouselInEditIndex: -1,
        };
    }
    updateCarousel =( index, id, data ) => {
        this.props.updateCarousel( id, data )
        .then( ( carousel ) => {
            return this.props.onCarouselUpdated && this.props.onCarouselUpdated( index, carousel );
        } );
    }
    openEditModal = ( index, carousel ) => {
        this.setState( { carouselInEdit: carousel, carouselInEditIndex: index } );
    }
    onEditSubmit = ( carousel ) => {
        var index = this.state.carouselInEditIndex;
        this.props.onCarouselUpdated( index, carousel );
        this.setState( { carouselInEdit: null, carouselInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { carouselInEdit: null, carouselInEditIndex: -1 } );
    }

    render() {
        const { carousels } = this.props;

        return (
            <div>
                <InfiniteTable
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    { this.arrayTableRows( carousels ) }
                </InfiniteTable>
                { this.state.carouselInEdit &&
                    <EditCarouselModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    carousel={ this.state.carouselInEdit } />
                }
            </div>
        );
    }


    arrayTableRows = ( carousels ) => {
        var rows = carousels.map( ( carousel, index ) => {
            var individualSlug = `/admin/carousels/${ carousel.id }`;
            return (
                <InfiniteTable.Row key={ carousel.id } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        <TextTruncate text={ carousel.title }
                        line={ 2 } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { carousel.context }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { carousel.context_order }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { carousel.status }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }></Link>
                        { carousel.ui_type }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, carousel );
                            } }/>
                            <DLMenu.Item text={ (carousel.status !== 'published') ? 'Publish' : 'Unpublish' }
                            onClick={ () => {
                                this.updateCarousel( index, carousel.id, {
                                    status: (carousel.status !== 'published') ? 'published' : 'draft',
                                } );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );
        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    CAROUSEL TITLE { sortIcon( 'title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PAGE { sortIcon( 'context,context_order,title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PAGE<br />ORDER { sortIcon( 'context_order,title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    STATUS { sortIcon( 'status,title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    UI TYPE { sortIcon( 'ui_type,title,id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
AllCarouselsTable.defaultProps = {
    onCarouselUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateCarousel: ( id, data ) => {
            return dAPI.patch( `/admin/curated-carousels/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllCarouselsTable );
